import React, { FC, useState } from 'react';
import { Icons } from '@components/Icon';
import { IconTemplate } from '@components/Icon/IconTemplate';
import useTranslation from '@hooks/useTranslation';
import TitleTemplate, { TitleTagTypes } from '@ui/SectionTitle/Title';
import { publicAssets } from '@utils/url.utils';
import ContentWrapper from '../../ui/Content/Content';
import { Area, Areas, Categories, Category, Column, Image, Wrapper, WrapperCats } from './Education.elements';

interface EducationProps { }

enum CATEGORY_IDS {
    TAXES_AND_ACCOUNTING = 0,
    WAGES_AND_HR = 1,
    GOVERNMENT = 2,
    OTHER_LEGISLATION = 3,
}

const EducationTemplate: FC<EducationProps> = () => {
    const { t } = useTranslation();

    const [activeCategoryId, setActiveCategoryId] = useState(CATEGORY_IDS.TAXES_AND_ACCOUNTING);

    return (
        <ContentWrapper withPadding mobileSidePadding={20}>
            <WrapperCats>
                <TitleTemplate tagType={TitleTagTypes.H2} isBlack>
                    {t('about.education.title')}
                </TitleTemplate>
                <Categories>
                    <Category
                        onClick={() => setActiveCategoryId(CATEGORY_IDS.TAXES_AND_ACCOUNTING)}
                        className={activeCategoryId === CATEGORY_IDS.TAXES_AND_ACCOUNTING ? 'active' : ''}
                    >
                        {t('about.education.label1')}
                    </Category>
                    <Category
                        onClick={() => setActiveCategoryId(CATEGORY_IDS.WAGES_AND_HR)}
                        className={activeCategoryId === CATEGORY_IDS.WAGES_AND_HR ? 'active' : ''}
                    >
                        {t('about.education.label2')}
                    </Category>
                    <Category
                        onClick={() => setActiveCategoryId(CATEGORY_IDS.GOVERNMENT)}
                        className={activeCategoryId === CATEGORY_IDS.GOVERNMENT ? 'active' : ''}
                    >
                        {t('about.education.label3')}
                    </Category>
                    <Category
                        onClick={() => setActiveCategoryId(CATEGORY_IDS.OTHER_LEGISLATION)}
                        className={activeCategoryId === CATEGORY_IDS.OTHER_LEGISLATION ? 'active' : ''}
                    >
                        {t('about.education.label4')}
                    </Category>
                </Categories>
            </WrapperCats>
            <Wrapper>
                <>
                    <Areas>
                        {activeCategoryId === CATEGORY_IDS.TAXES_AND_ACCOUNTING && (
                            <Column>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area1')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area2')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area3')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area4')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area5')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area6')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area7')}
                                </Area>
                            </Column>
                        )}
                        {activeCategoryId === CATEGORY_IDS.TAXES_AND_ACCOUNTING && (
                            <Column>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area8')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area9')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area10')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area11')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area12')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.other')}
                                </Area>
                            </Column>
                        )}
                        {activeCategoryId === CATEGORY_IDS.WAGES_AND_HR && (
                            <Column>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area13')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area14')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area15')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area16')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area17')}
                                </Area>
                            </Column>
                        )}
                        {activeCategoryId === CATEGORY_IDS.WAGES_AND_HR && (
                            <Column>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area18')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area19')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area20')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area21')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area22')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.other')}
                                </Area>
                            </Column>
                        )}
                        {activeCategoryId === CATEGORY_IDS.GOVERNMENT && (
                            <Column>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area23')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area24')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area25')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area26')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area27')}
                                </Area>
                            </Column>
                        )}
                        {activeCategoryId === CATEGORY_IDS.GOVERNMENT && (
                            <Column>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area28')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area29')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area30')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area38')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.other')}
                                </Area>
                            </Column>
                        )}
                        {activeCategoryId === CATEGORY_IDS.OTHER_LEGISLATION && (
                            <Column>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area31')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area32')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area33')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area34')}
                                </Area>
                            </Column>
                        )}
                        {activeCategoryId === CATEGORY_IDS.OTHER_LEGISLATION && (
                            <Column>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area35')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area36')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area37')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area38')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.other')}
                                </Area>
                            </Column>
                        )}
                    </Areas>
                </>
                <Image src={publicAssets('/education.svg')} />
            </Wrapper>
        </ContentWrapper>
    );
};
export default EducationTemplate;
